import { LOADING } from '../action';
const RootReducer = (state = { loggedIn:false } , action) => {
    switch(action.type){
        case LOADING:
            return {
                ...state,
                padeLoad: action.payload
            }
        default:
            return state
    }
}

export default RootReducer;